export default __webpack_public_path__ + "static/media/img-12.12c00904.jpg";